import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';
import { TranscriptonMenuView } from './TranscriptionMenuView';
import { useTranscriptionMenuCapture } from './useTranscriptionMenuCapture';

export interface Props {
  start: number;
  end: number;
}

export function TranscriptonMenuContainer(p: Props) {
  const {
    clearSelection,
    canStartSelection,
    canEndSelection,
    setSelectionStart,
    setSelectionEnd,
    selection: { tsA, tsB },
  } = useStreamSelection();
  const capture = useTranscriptionMenuCapture();

  const allowStartSelection = canStartSelection(p.start);
  const allowEndSelection = canEndSelection(p.end);
  const allowClearSelection = Boolean(tsA || tsB);

  return (
    <TranscriptonMenuView
      startSelection={
        allowStartSelection
          ? () => {
              capture('start_selection');
              setSelectionStart(p.start);
            }
          : null
      }
      endSelection={
        allowEndSelection
          ? () => {
              capture('end_selection');
              setSelectionEnd(p.end);
            }
          : null
      }
      clear={
        allowClearSelection
          ? () => {
              capture('clear');
              clearSelection();
            }
          : null
      }
    />
  );
}
